export default __webpack_public_path__ + "alberta-fab-fax.da54aee029a72be1d89e.svg";